import { NESWBounds } from 'google-map-react';
import { BBox2d } from '@turf/helpers/dist/js/lib/geojson';

const boundsToBBox = (optionalBounds?: NESWBounds): BBox2d | undefined =>
  optionalBounds && [
    optionalBounds.nw?.lng || optionalBounds.sw?.lng,
    optionalBounds.se?.lat || optionalBounds.ne?.lat,
    optionalBounds.se?.lng || optionalBounds.ne?.lng,
    optionalBounds.nw?.lat || optionalBounds.sw?.lat,
  ];

export default boundsToBBox;
